<template>
  <div id="form-revision">
    <v-btn color="lime darken-2" dark class="mb-3" @click="volver()">
      <v-icon right dark>arrow_back_ios</v-icon>Volver
    </v-btn>
    <v-container grid-list-xl>
      <v-card>
        <v-toolbar color="white" dark flat dense cad>
          <v-toolbar-title class="indigo--text">{{
            titleView
          }}</v-toolbar-title>
        </v-toolbar>
        <v-layout>
          <v-flex xs12 md1></v-flex>
          <v-flex xs12 md12>
            <!-- INICIO DATOS -->
            <template>
              <v-form ref="form" v-model="validacion" lazy-validation>
                <v-layout>
                  <v-spacer></v-spacer>
                  <v-flex xs12 md4>
                    <v-menu
                      v-model="menu1"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="fechaTraspaso"
                          label="Fecha Traspaso"
                          :box="tipeView !== 'crear'"
                          :readonly="tipeView !== 'crear'"
                          prepend-icon="event"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="fechaTraspaso"
                        no-title
                        @input="menu1 = false"
                        locale="es"
                        first-day-of-week="1"
                      >
                      </v-date-picker>
                    </v-menu>
                  </v-flex>
                </v-layout>
                <v-layout>
                  <v-flex md5>
                    <v-select
                      v-model="regionValue"
                      :items="regionesSelect"
                      item-text="nombre"
                      item-value="code"
                      label="Region"
                      :box="tipeView !== 'crear'"
                      :readonly="tipeView !== 'crear'"
                      @change="loadCentrosOrigen()"
                      @input="$v.regionValue.$touch()"
                      @blur="
                        tipeView == 'crear' ? $v.regionValue.$touch() : null
                      "
                    ></v-select>
                    <v-select
                      v-model="centroOrigenValue"
                      :items="centroOrigenSelect"
                      item-text="nombre"
                      item-value="code"
                      label="Centro Origen"
                      :box="tipeView !== 'crear'"
                      :readonly="tipeView !== 'crear'"
                      @input="$v.centroOrigenValue.$touch()"
                      @blur="
                        tipeView == 'crear'
                          ? $v.centroOrigenValue.$touch()
                          : null
                      "
                    ></v-select>

                    <v-text-field
                      v-model="cajaContenedora"
                      :error-messages="cajaContenedoraErrors"
                      label="Caja Contenedora"
                      :box="tipeView == 'consulta'"
                      :readonly="tipeView == 'consulta'"
                      @input="$v.cajaContenedora.$touch()"
                      @blur="
                        tipeView == 'crear' ? $v.cajaContenedora.$touch() : null
                      "
                      @change="autoCompleta()"
                    ></v-text-field>
                    <v-text-field
                      v-model="cajaDia1"
                      :error-messages="cajaDia1Errors"
                      label="Caja Dia 1"
                      :box="tipeView !== undefined"
                      :readonly="tipeView !== undefined"
                      @input="$v.cajaDia1.$touch()"
                      @blur="tipeView == 'crear' ? $v.cajaDia1.$touch() : null"
                    ></v-text-field>
                    <v-text-field
                      v-model="cajaDia2"
                      :error-messages="cajaDia2Errors"
                      label="Caja Dia 2"
                      :box="tipeView !== undefined"
                      :readonly="tipeView !== undefined"
                      @input="$v.cajaDia2.$touch()"
                      @blur="tipeView == 'crear' ? $v.cajaDia2.$touch() : null"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md1></v-flex>
                  <v-flex>
                    <v-select
                      v-model="nivelValue"
                      :items="nivelSelect"
                      item-text="nombre"
                      item-value="code"
                      label="Nivel"
                      :box="tipeView !== undefined"
                      :readonly="tipeView !== undefined"
                      @input="$v.nivelValue.$touch()"
                      @blur="
                        tipeView == 'crear' ? $v.nivelValue.$touch() : null
                      "
                    ></v-select>
                    <v-text-field
                      v-model="rbd"
                      :error-messages="rbdErrors"
                      label="RBD"
                      :box="tipeView !== undefined"
                      :readonly="tipeView !== undefined"
                      @input="$v.rbd.$touch()"
                      @blur="tipeView == 'crear' ? $v.rbd.$touch() : null"
                    ></v-text-field>
                    <v-text-field
                      v-model="codCurso"
                      :error-messages="cursoErrors"
                      label="Curso"
                      :box="tipeView !== undefined"
                      :readonly="tipeView !== undefined"
                      @input="$v.codCurso.$touch()"
                      @blur="tipeView == 'crear' ? $v.codCurso.$touch() : null"
                    ></v-text-field>
                    <v-text-field
                      v-model="numGuiaDespacho"
                      :error-messages="numGuiaDespachoErrors"
                      label="Numero Guia Despacho"
                      :box="tipeView !== 'crear'"
                      :readonly="tipeView !== 'crear'"
                      @input="$v.numGuiaDespacho.$touch()"
                      @blur="
                        tipeView == 'crear' ? $v.numGuiaDespacho.$touch() : null
                      "
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-form>
            </template>
            <!-- TERMINO DATOS -->
          </v-flex>
          <v-flex xs12 md1></v-flex>
        </v-layout>
        <v-layout>
          <v-container>
            <v-flex xs12>
              <v-textarea
                v-model="observacion"
                label="Observaciones"
                :readonly="tipeView == 'consulta'"
                :box="tipeView == 'consulta'"
              ></v-textarea>
            </v-flex>
          </v-container>
        </v-layout>
        <v-card-actions class="pb-3">
          <v-spacer></v-spacer>
          <v-btn
            v-if="tipeView == 'crear' || tipeView == 'modifica'"
            :loading="loading"
            color="primary"
            @click="save()"
            >Guardar <v-icon right dark>save</v-icon></v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-container>
  </div>
</template>
<script>
import { validationMixin } from "vuelidate";
import { misMixins } from "@/mixins/myMixing.js";
import AlertEmpty from "@/views/ui/AlertEmpty.vue";

export default {
  name: "FormRevision",
  components: {
    AlertEmpty,
  },
  mixins: [misMixins, validationMixin],
  props: {
    rowsTable: "",
  },

  data() {
    return {
      dialogValidation: false,
      loading: false,
      alertaRecibidos: false,
      dialog: false,
      visibleNew: false,
      userlogged: "",
      // -----REVISION----
      fechaTraspaso: "",
      observacion: "",
      regionValue: "",
      regionesSelect: [],
      centroOrigenValue: "",
      centroOrigenSelect: [],
      cajaContenedora: "",
      cajaDia1: "",
      cajaDia2: "",
      codigoBarraSobre: "",
      rbd: "",
      codCurso: "",
      nivelValue: "",
      nivelSelect: [],
      tipeView: "",
      registroAutoCompleta: [],
      numGuiaDespacho: "",
    };
  },

  validations: {},

  created() {
    this.tipeView = this.$route.params.tipeView;
    this.titleView = this.$route.params.titleView;
    this.idContrato = this.$store.getters.contratoStored;
    this.loadDataComuna();
  },
  mounted() {},
  computed: {
    selectErrors() {
      const errors = [];
      if (!this.$v.tipoCentroValue.$dirty) return errors;
      !this.$v.tipoCentroValue.required && errors.push("Item es requerido");
      return errors;
    },
  },
  methods: {
    async autoCompleta() {
      this.loadData();
    },
    //  CENTROS POR REGION ORIGEN
    async loadCentrosOrigen() {
      this.centroOrigen = await this.loadCentroOrigenData();
      let centros = [];
      this.centroOrigen.forEach(function (c) {
        centros.push({ nombre: c.code, code: c.code });
      });
      this.centroOrigenSelect = centros;
    },
    async loadCentroOrigenData() {
      return await axios
        .get(
          "/traspasoCaptura/getallCentroAco_Opa/" +
            this.idContrato +
            "/" +
            this.regionValue
        )
        .then((response) => {
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
          return [];
        });
    },

    async loadData() {
      if (
        this.regionValue != null &&
        this.regionValue != undefined &&
        this.regionValue != "" &&
        this.cajaContenedora != null &&
        this.cajaContenedora != undefined &&
        this.cajaContenedora != ""
      ) {
        this.registroAutoCompleta = await this.loadRegistroData();

        if (
          this.registroAutoCompleta !== undefined &&
          this.registroAutoCompleta != "" &&
          this.registroAutoCompleta != null
        ) {
          this.cajaDia1 = this.registroAutoCompleta.cajaDia1;
          this.cajaDia2 = this.registroAutoCompleta.cajaDia2;
          this.codCurso = this.registroAutoCompleta.codigoCurso;
          this.rbd = this.registroAutoCompleta.rbd;
          this.nivelValue = {
            nombre: this.registroAutoCompleta.idNivel.descripcion,
            code: this.registroAutoCompleta.idNivel.codNivelAce,
          };
          this.nivelSelect = [
            {
              nombre: this.registroAutoCompleta.idNivel.descripcion,
              code: this.registroAutoCompleta.idNivel.codNivelAce,
            },
          ];
        }
      }
    },

    async loadRegistroData() {
      return await axios
        .get(
          "/traspasoCaptura/AutoCompletaCentro/" +
            this.idContrato +
            "/" +
            this.regionValue +
            "/" +
            this.cajaContenedora
        )
        //.get("/traspasoCaptura/AutoCompletaCentro/" + 38 + "/" + 12 + "/" + "541000002")
        .then((response) => {
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
          return [];
        });
    },

    save() {
      if (this.tipeView == "crear") {
        this.loading = true;
        this.saveTraspaso();
        this.loading = false;
      }
    },

    saveTraspaso() {
      this.loading = true;
      let idContrato = this.$store.getters.contratoStored;
      this.body = {
        idContrato: idContrato,
        codeRegion: this.regionValue,
        codeCentro: this.centroOrigenValue,
        codeNivel: this.nivelValue.code,
        cajaContenedora: this.cajaContenedora,
        cajaDia1: this.cajaDia1,
        cajaDia2: this.cajaDia2,
        rbd: this.rbd,
        codCurso: this.codCurso,
        guiaDespacho: this.numGuiaDespacho,
        observaciones: this.observacion,
        fecha_entrega: this.formatoFecha(this.fechaTraspaso),
      };
      m;
      axios
        .post("/traspasoCaptura/NewTraspasoCaptura", this.body)
        .then((response) => {
          this.resp = response.data;
          this.loading = false;
          window.getApp.$emit("APP_SAVE");
          this.volver();
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
            window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
            this.loading = false;
          }
        });
    },
    volver() {
      setTimeout(() => {
        this.$router.push({
          name: "ProcesoAplicacion",
        });
      }, 1000);
    },
  },
};
</script>
